var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoRepresionGenero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "28px",
    viewBox: "0 0 24 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-represion-genero") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24 0 24 27.6910159 0 27.6910159"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "P\\xE1gina-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post-Square",
    transform: "translate(-284, -718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-represion-genero",
    transform: "translate(284, 718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8753136,3.00221038 C23.5241846,2.13859195 22.5412504,1.72155516 21.674223,2.07382057 L6.1904536,8.36687171 C6.41772161,5.34647989 8.92221505,2.94993874 12.0005602,2.94993874 C12.815316,2.94993874 13.4755296,2.28972518 13.4755296,1.47496937 C13.4755296,0.660213563 12.815316,0 12.0005602,0 C7.14611557,0 3.19733394,3.94878164 3.19733394,8.80208995 C3.19733394,9.06117548 3.21437904,9.31571564 3.2359695,9.56798313 L1.05419662,10.4554647 C0.189441851,10.8065938 -0.226458604,11.7918006 0.124670468,12.6565554 C0.391710378,13.3122236 1.02351544,13.7099426 1.69054704,13.7099426 C1.69963776,13.7099426 1.70872848,13.7076699 1.7178192,13.7065336 C1.92122407,13.7031245 2.12576528,13.6656253 2.32576112,13.5849452 L4.18140441,12.8304154 L6.94839241,11.7054387 L22.2037574,5.50443115 L22.9469238,5.20330104 C23.8105423,4.85103563 24.2264427,3.86582881 23.8753136,3.00221038 M13.8630215,17.4030477 L13.8630215,20.2666246 L17.8027125,20.2666246 C18.6174683,20.2666246 19.2776818,20.9268382 19.2776818,21.741594 C19.2776818,22.5563498 18.6174683,23.2165633 17.8027125,23.2165633 L13.8630215,23.2165633 L13.8630215,26.2165011 C13.8630215,27.0312569 13.2039443,27.6914704 12.3891885,27.6914704 C11.5744327,27.6914704 10.9142191,27.0312569 10.9142191,26.2165011 L10.9142191,23.2165633 L6.97566457,23.2165633 C6.16090876,23.2165633 5.5006952,22.5563498 5.5006952,21.741594 C5.5006952,20.9268382 6.16090876,20.2666246 6.97566457,20.2666246 L10.9142191,20.2666246 L10.9142191,17.5314541 C8.64722077,17.2507781 6.64498962,16.1110291 5.24842771,14.4417456 L8.21654789,13.2315434 C9.24039027,14.1076616 10.5517267,14.6565138 12.0005602,14.6565138 C15.0482242,14.6565138 17.5299909,12.3054263 17.8004398,9.32707904 L20.6458352,8.16687586 C20.7390151,8.36119001 20.8026502,8.57254926 20.8026502,8.80208995 C20.8026502,13.0179115 17.8243029,16.545111 13.8630215,17.4030477",
    id: "Fill-9",
    fill: "#A3233B",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRepresionGenero);
export default __webpack_public_path__ + "static/media/ico-represion-genero.e008df48.svg";
export { ForwardRef as ReactComponent };